import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-grid-close',
  standalone: false,
  template: `
    <div style="padding: 20px;">
      <h2 style="margin: 0 0 8px; font-size: 16px; font-weight: 600;">Save Grid?</h2>
      <p style="font-size: 13px; color: #6b7280; margin-bottom: 20px;">You have unsaved grid points. Would you like to save them before closing?</p>
      <div style="display: flex; justify-content: space-between; gap: 8px;">
        <button mat-flat-button color="primary" (click)="dialogRef.close('save')">Yes</button>
        <button mat-button color="warn" (click)="dialogRef.close('no')">No</button>
        <button mat-button (click)="dialogRef.close('cancel')">Cancel</button>
      </div>
    </div>
  `
})
export class ConfirmGridCloseComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmGridCloseComponent>) {}
}
